<template>
  <div
    :class="['connection-box', 'bottom-md', mobileBoxClass]"
    name="step4-check-side"
    v-if="sideMonitoring">
    <div class="before">
      <div class="row qr-ol">
        <div class="col-auto">
          <img ref="qr" alt="QR코드" />
        </div>
        <div class="col ml-md">
          <ol>
            <li>
              <span>1</span>
              {{ $t('preRegistration.step4.side.guide.row1.text1') }}
            </li>
            <li>
              <span>2</span>
              {{ $t('preRegistration.step4.side.guide.row2') }}
            </li>
          </ol>
        </div>
      </div>
      <div></div>
    </div>
    <div class="after">
      <div class="video-box">
        <div class="text-item video-text">
          <p>{{ $t('preRegistration.step4.side.ready') }}</p>
        </div>
        <video
          autoplay=""
          playsinline=""
          class="face_video reverse"
          muted=""
          id="mobile"
          ref="mobile"></video>
      </div>
    </div>
    <div class="cam-print-done">
      <div class="icon-confirm">
        <p>{{ $t('preRegistration.step4.side.connectComplete') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    DEVICE_TYPE,
    CONNECT_CHECK_PHASE,
    otmUserServerUrl,
    DEFAULT_VIDEO_CHECK_TIMEOUT,
  } from '@/js/common/constants';
  import AntMediaConnectCheck from '@/js/video/antmedia/AntMediaConnectCheck';
  import {makeQR} from '@/js/common/util';
  import AntMediaRest from '@/js/video/antmedia/rest';
  const antMediaRest = new AntMediaRest();

  export default {
    name: 'Mobile',

    props: {
      userId: {
        type: Number,
      },
      roomId: {
        type: String,
      },
      sideMonitoring: {
        type: Boolean,
        default: false,
      },
      phase: {
        type: Number,
      },
      active: {
        type: Boolean,
        default: false,
      },
      done: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        webRTCAdaptor: null,

        timeoutId: null,
        roomInfoId: null,
      };
    },

    mounted() {
      this.createQR();
    },

    methods: {
      createQR() {
        makeQR(
          this.$refs['qr'],
          `${otmUserServerUrl}/pages/monitoring_mobile_connect_check.html${window.location.search}`,
        );

        this.$forceUpdate();
      },

      openWebRTC() {
        const {
          userId,
          roomId: videoRoomId,
          handleMobileConnected,
          handlePlayStarted,
          handlePlayFinished,
        } = this;

        this.webRTCAdaptor = new AntMediaConnectCheck({
          videoRoomId,
          publishType: DEVICE_TYPE['MOBILE'],
          userId,
          isPlayMode: true,
          handleMobileConnected,
          handlePlayStarted,
          handlePlayFinished,
        });
      },

      handleMobileConnected(stream) {
        const mobileVideo = this.$refs['mobile'];
        if (mobileVideo.srcObject) return;

        mobileVideo.srcObject = stream;
      },

      handlePlayStarted() {
        this.$emit('changeMobileActive', true);

        this.timeoutId = setTimeout(() => {
          this.closeWebRTC();

          this.$emit('changeMobileActive', false);
          this.$emit('connectStatusChanged', DEVICE_TYPE['MOBILE'], true);
        }, DEFAULT_VIDEO_CHECK_TIMEOUT);
      },

      handlePlayFinished() {
        this.webRTCAdaptor.closeWebSocket();
      },

      async restRoomInfo() {
        const roomInfo = await antMediaRest.roomInfo(this.roomId);
        const {streamDetailsMap} = roomInfo.data;

        if (
          !streamDetailsMap ||
          !this.webRTCAdaptor.publishStreamId ||
          !streamDetailsMap[this.webRTCAdaptor.publishStreamId]
        )
          return;

        this.webRTCAdaptor.play();
        clearInterval(this.roomInfoId);
      },

      handleIntervalRoomInfo() {
        this.roomInfoId = setInterval(() => {
          this.restRoomInfo();
        }, 3000);
      },

      closeWebRTC() {
        this.webRTCAdaptor.stopStream();
      },
    },

    computed: {
      mobileBoxClass() {
        return {
          'tab-selected': this.phase === CONNECT_CHECK_PHASE['MOBILE'],
          active: this.active,
          done: this.done,
        };
      },
    },

    watch: {
      webRTCAdaptor(newValue, oldValue) {
        if (newValue === oldValue || !newValue) return;

        this.handleIntervalRoomInfo();
      },

      phase(newValue) {
        if (newValue === CONNECT_CHECK_PHASE['MOBILE']) {
          this.openWebRTC();
        }
      },
    },
  };
</script>
